// extracted by mini-css-extract-plugin
module.exports = {"textBlockWrapper":"TextBlock_textBlockWrapper__NT7kT","textBlockContainer":"TextBlock_textBlockContainer__4Byhf","textBlockContent":"TextBlock_textBlockContent__t9FjA"};